import { getProductFlowConfiguration } from '@flows/configs/shared/flowConfiguration'
import type { FlowConfigProps, StepConfigParams } from '@flows/configs/types'
import { SubFlow } from '@flows/insurance/types/subFlowTypes'
import * as flowConfigUtils from '@flows/insurance/utils'

import schema from './schema'
import getSteps from './steps'

const getHouseholdAtConfig = ({
  clientHelpers,
  subFlow = SubFlow.HouseholdAt,
}: FlowConfigProps) => {
  const productKey = 'household_v1_getsafe_at'
  const stepParams = {
    productKey,
    clientHelpers,
    helperFunctions: flowConfigUtils.generateGetFlowValueFunctions(productKey),
    subFlow,
  } satisfies StepConfigParams

  return getProductFlowConfiguration(productKey, getSteps(stepParams), {
    constants: {
      FIRST_STEP_NAME: 'household_at_zip',
      SCHEMA: schema,
    },

    getInitialValues: () => ({
      [productKey]: {
        productKey,
        configuration_parameters: {
          tariff_line: 'premium',
        },
      },
    }),
  })
}

export default getHouseholdAtConfig
